"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (labels, shapes) {
    var labelBBox;
    var shapeBBox;
    var toBeRemoved = [];
    for (var i = 0; i < labels.length; i++) {
        labelBBox = labels[i].getBBox();
        shapeBBox = shapes[i].getBBox();
        if (labelBBox.width > shapeBBox.width || labelBBox.height > shapeBBox.height) {
            toBeRemoved.push(labels[i]);
        }
        // FIXME this is not going to be true
        // } else if (labelBBox.width * labelBBox.height > shapeBBox.width * shapeBBox.height) {
        //   toBeRemoved.push(labels[i]);
        // }
    }
    for (var i = 0; i < toBeRemoved.length; i++) {
        toBeRemoved[i].remove();
    }
});
//# sourceMappingURL=bbox.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/component/lib/label/adjust/bbox.js
// module id = 773
// module chunks = 37